// src/pages/Blog.js
import React, { useEffect, useState, useRef } from "react";

import articlePic1 from "../assets/article_pic_1.png";
import articlePicEvaluation from "../assets/article_pic_evaluation.png";
import aiJournal from "../assets/blog/ai_journal.jpg";
import coindesk from "../assets/blog/coindesk.avif";
import nasdaq from "../assets/blog/nasdaq.webp";
import om1Announcement from "../assets/blog/om1_announcement.jpg";
import dimoPic from "../assets/blog/OpenMind_DIMO.jpg";
import techTransit from "../assets/blog/tech_transit.jpeg";
import ventureBeat from "../assets/blog/venturebeat.webp";
import partnershipPicDimo from "../assets/partnership_pic_dimo.png";
import reportPdf from "../assets/research/report.pdf";
import researchPicDec24 from "../assets/research_pic_dec24.png";
import researchPicJan25 from "../assets/research_pic_jan25.png";
import BlogCard from "../components/BlogCard";
import Chatbot from "../components/Chatbot";
import FeaturedBlog from "../components/FeaturedBlog";
import SEO from "../components/SEO";

const Blog = () => {
  const blogData = [
    {
      section: "Article",
      title:
        "For the First Time Ever, a Humanoid Robot Rings the Nasdaq Opening Bell",
      description:
        "Jan Liphardt featured on a press release provided to Bitcoin.com",
      date: "Jun 26th, 2025",
      image: nasdaq,
      link: "https://news.bitcoin.com/for-the-first-time-ever-a-humanoid-robot-rings-the-nasdaq-opening-bell/",
    },
    {
      section: "Article",
      title: "From Walled Gardens to Connected Minds",
      description:
        "Exploring how secure, open robotic networks can unlock rapid knowledge sharing and transform industries.",
      date: "Jun 13th, 2025",
      image: aiJournal,
      link: "https://aijourn.com/from-walled-gardens-to-connected-minds/",
    },
    {
      section: "Podcast",
      title:
        "Navigating the Ethics of AI and the Tech Jobs of Tomorrow with Jan Liphardt",
      date: "Jun 4th, 2025",
      image: techTransit,
      link: "https://open.spotify.com/episode/0hVaosveqF45iB0xUjr3Pu?si=yS175Gq0SiG5-B0bxOLuiA",
    },
    {
      section: "Partnerships",
      title: "OpenMind x DIMO: Robotics Forward Together",
      description:
        "OpenMind & DIMO: Unlocking Cross-Machine Communication with Blockchain.",
      date: "Apr 16th, 2025",
      image: partnershipPicDimo,
      link: "https://openmindagi.substack.com/p/openmind-and-dimo-unlocking-cross",
    },
    {
      section: "Article",
      title:
        "OpenMind and DIMO provide car-to-robot connectivity to realize smart cities",
      date: "Apr 9th, 2025",
      image: dimoPic,
      link: "https://www.therobotreport.com/openmind-and-dimo-provide-car-robot-connectivity-realize-smart-cities/",
    },
    {
      section: "Product Announcement",
      title:
        "OpenMind Makes Human-Machine Collaboration System Open to the Public",
      description:
        "OpenMind debuts its cutting-edge, open-source intelligent agent framework, OM1, at the Coinbase AI Hackathon.",
      date: "Feb 1st, 2025",
      image: om1Announcement,
      link: "https://apnews.com/press-release/globenewswire-mobile/openmind-makes-human-machine-collaboration-system-open-to-the-public-6eb700da7bd59b9400e86c033d14a69b",
    },
    {
      section: "Article",
      title: "Building Out Effective Agentic Evaluation Systems",
      author: "Adam Zhou",
      date: "Feb 1st, 2025",
      image: articlePicEvaluation,
      link: "https://openmindagi.substack.com/p/building-out-effective-agentic-evaluation",
    },
    {
      section: "Article",
      title: "OpenMind is fast-tracking a future of human-robot collaboration",
      description:
        "OpenMind explores how open systems, shared infrastructure, and machine collaboration are shaping a more connected, collective approach to intelligence.",
      date: "Jan 31st, 2025",
      image: ventureBeat,
      link: "https://venturebeat.com/business/openmind-is-fast-tracking-a-future-of-human-robot-collaboration/",
    },
    {
      section: "Research",
      title:
        "A Paragraph is All It Takes: Rich Robot Behaviors from Interacting, Trusted LLMs",
      description:
        "Discover how LLMs and blockchain enable robots with rich, adaptable behaviors, human-aligned reasoning, and secure constraints through natural language communication and immutable public ledgers.",
      image: researchPicJan25,
      link: "https://arxiv.org/pdf/2412.18588",
    },
    {
      section: "Article",
      title:
        "Trusted Autonomy: Why Human-Machine Teams Will Run on Crypto Networks",
      description:
        "Accelerating the future of robotics with a coordination layer for open autonomy. Learn how its system enables real-world collaboration between humans and intelligent machines.",
      date: "Jan 7th, 2025",
      image: coindesk,
      link: "https://www.coindesk.com/opinion/2025/01/07/trusted-autonomy-why-human-machine-teams-will-run-on-crypto-networks",
    },
    {
      section: "Research",
      title: "Towards Trusted Autonomy: Robotics, AI, and Blockchain",
      description:
        "Explore how blockchain technologies can enable secure, verifiable autonomous systems by providing critical infrastructure for robot identity, transactions, and coordination in an AI-powered future.",
      image: researchPicDec24,
      link: reportPdf,
    },
    {
      section: "Article",
      title: "Crypto – AGI's fundamental payment and governance rail",
      author: "Jan Liphardt",
      date: "Aug 30th, 2024",
      image: articlePic1,
      link: "https://janliphardt.com",
    },
  ];

  const blogContainerRef = useRef(null);
  const [rightmostItems, setRightmostItems] = useState([]);

  useEffect(() => {
    const updateRightmostItems = () => {
      if (!blogContainerRef.current) return;

      const container = blogContainerRef.current;
      const blogCards = container.querySelectorAll(".blog-card-wrapper");
      const rightmostIndices = [];

      let currentRowY = -1;
      let rightmostXInRow = -1;
      let rightmostIndexInRow = -1;

      blogCards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();

        if (currentRowY === -1 || Math.abs(rect.top - currentRowY) > 10) {
          if (rightmostIndexInRow !== -1) {
            rightmostIndices.push(rightmostIndexInRow);
          }

          currentRowY = rect.top;
          rightmostXInRow = rect.right;
          rightmostIndexInRow = index;
        } else if (rect.right > rightmostXInRow) {
          rightmostXInRow = rect.right;
          rightmostIndexInRow = index;
        }
      });

      if (rightmostIndexInRow !== -1) {
        rightmostIndices.push(rightmostIndexInRow);
      }

      setRightmostItems(rightmostIndices);
    };

    updateRightmostItems();
    window.addEventListener("resize", updateRightmostItems);

    return () => {
      window.removeEventListener("resize", updateRightmostItems);
    };
  }, []);

  const blogJsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "OpenMind Blog Feed",
    description: "AI Robotics research and insights from OpenMind team",
    url: "https://openmind.org/blog",
    publisher: {
      "@type": "Organization",
      name: "OpenMind",
      url: "https://openmind.org",
      logo: {
        "@type": "ImageObject",
        url: "https://openmind.org/static/media/Logo-OpenMind_black.2940e33779fec2f95609c1cf55a860f7.svg",
      },
    },
    blogPost: blogData.map((link) => ({
      "@type": "BlogPosting",
      headline: link.title,
      image: link.image,
      description: link.description,
      url: link.url,
    })),
  };

  const featuredBlog = blogData[0];
  const remainingBlogs = blogData.slice(1);

  return (
    <>
      <SEO
        title="Blog - OpenMind"
        description="OpenMind's Blog"
        canonical="https://openmind.org/blog"
        keywords="openmind, om1, fabric, ai, robot, operating system, open source, robot operating system, ai robot operating system, om1 fabric, blog, tech talk, research, article"
      />
      <script type="application/ld+json">{JSON.stringify(blogJsonLd)}</script>
      <section className="flex justify-center px-12 py-12">
        <div className="max-w-[1250px]">
          <h1 className="text-5xl font-normal mb-10">BLOG</h1>

          {/* Featured Article Section */}
          <FeaturedBlog {...featuredBlog} />

          <div className="mb-16">
            <div
              ref={blogContainerRef}
              className="flex flex-wrap gap-12 relative"
            >
              {remainingBlogs.map((item, index) => (
                <div key={index} className="w-96 relative blog-card-wrapper">
                  <BlogCard {...item} />
                  {index < remainingBlogs.length - 1 &&
                    !rightmostItems.includes(index) && (
                      <div className="hidden md:block absolute -right-6 top-0 h-full w-[2px] bg-gray-300"></div>
                    )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <Chatbot />
      </section>
    </>
  );
};

export default Blog;
